<div class="modal-header">
  <h1 class="modal-title" id="modal-basic-title">
    {{ 'Welcome to Lenovo 360 Boost' | translate }}
  </h1>
</div>
<div class="modal-body">

  <div class="w-100 mt-4">
    <form class="d-flex align-items-center justify-content-center flex-column">
      <div class="form-row w-100">
        <div class="d-flex align-items-center terms-form flex-column">
          <button class="btn btn-primary btn-enroll" type="button" (click)="onSubmit()">{{ 'Enroll' | translate }} <fa-icon [icon]="['far', 'chevron-right']"></fa-icon></button>
          <p class="prompt">
            {{ 'By clicking enroll, you have accepted the lenovo 360 boost' | translate }} 
            <a href="{{ termsAndConditionsUrl$ | async }}" target="_blank">{{ 'Terms & Conditions' | translate }}</a>
          </p>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
</div>
